import { motion } from 'framer-motion';
import { Users, Home } from 'lucide-react';

const properties = [
  {
    id: 'cabana-concept',
    name: 'Cabana Concept',
    type: 'Cabana de Vidro',
    capacity: 2,
    price: 1250,
    mainImage: '/images/Cabana-Concept/Capa.jpg',
    description: 'Teto e paredes de vidro com vista das árvores e estrelas. Piscina privativa aquecida, cinema ao ar livre e automação completa.',
    highlights: [
      'Piscina privativa aquecida',
      'Cinema ao ar livre com telão de 106"',
      'Fire pit externo',
      'Rede suspensa na natureza',
      'Automação por voz (Alexa)',
      'Pet friendly'
    ],
    amenities: [
      'Cama queen',
      'Smart TV',
      'Cozinha completa',
      'Air Fryer',
      'Cafeteira Nespresso',
      'Ar-condicionado'
    ]
  },
  {
    id: 'cabana-aurora',
    name: 'Cabana Aurora',
    type: 'Cabana de Vidro',
    capacity: 2,
    price: 1160,
    mainImage: '/images/Cabana-Aurora/IMG_0065.jpg',
    description: 'Vista direta da mata através do teto e paredes de vidro. Piscina aquecida, fire pit e cinema ao ar livre para noites mágicas.',
    highlights: [
      'Piscina privativa aquecida',
      'Cinema ao ar livre com telão de 106"',
      'Fire pit externo',
      'Rede suspensa',
      'Automação por voz (Alexa)',
      'Pet friendly'
    ],
    amenities: [
      'Cama queen',
      'Smart TV',
      'Cozinha completa',
      'Air Fryer',
      'Cafeteira Nespresso',
      'Ar-condicionado'
    ]
  },
  {
    id: 'casa-m5',
    name: 'Casa M5',
    type: 'Casa Completa',
    capacity: 10,
    price: 2560,
    mainImage: '/images/Casa-M5/0905f41d-f5e8-483d-ac6f-cb1dfc2957bc.jpg',
    description: 'Casa espaçosa com 5 quartos (4 suítes), rede suspensa ampla e área gourmet completa. Ideal para famílias e grupos.',
    highlights: [
      '5 quartos climatizados',
      '4 suítes completas',
      'Área gourmet com churrasqueira',
      'Rede suspensa ampla',
      'Projeto de paisagismo exclusivo',
      'Som de cachoeira'
    ],
    amenities: [
      'Smart TV',
      'Cozinha completa',
      'Área gourmet',
      'Churrasqueira',
      'Ar-condicionado',
      'Banheiros espaçosos'
    ]
  }
];

const Accommodations = ({ onSelectProperty }) => {
  return (
    <section id="accommodations" className="py-24 md:py-32 px-6">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <p className="text-xs tracking-[0.2em] uppercase font-bold text-accent mb-4">
            Nossas Acomodações
          </p>
          <h2 className="text-4xl md:text-5xl font-light tracking-tight text-primary">
            Escolha Seu Refúgio
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {properties.map((property, index) => (
            <motion.div
              key={property.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
              className={`group relative overflow-hidden rounded-3xl bg-white shadow-soft hover:shadow-deep transition-all cursor-pointer ${
                index === 0 ? 'md:col-span-2' : ''
              }`}
              onClick={() => onSelectProperty(property)}
              data-testid={`property-card-${property.id}`}
            >
              <div className="relative h-[400px] md:h-[500px] overflow-hidden">
                <img
                  src={property.mainImage}
                  alt={property.name}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
                <p className="text-xs tracking-[0.2em] uppercase font-bold text-accent mb-2">
                  {property.type}
                </p>
                <h3 className="text-2xl md:text-3xl font-normal mb-3">
                  {property.name}
                </h3>
                <p className="text-sm leading-relaxed text-white/90 mb-4">
                  {property.description}
                </p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4 text-sm">
                    <div className="flex items-center gap-2">
                      <Users size={16} />
                      <span>Até {property.capacity} pessoas</span>
                    </div>
                  </div>
                  <div className="bg-accent/90 backdrop-blur-sm px-4 py-2 rounded-full">
                    <p className="text-lg font-semibold">
                      R$ {property.price.toLocaleString('pt-BR')}
                    </p>
                    <p className="text-xs opacity-90">diária</p>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Accommodations;